import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FaEnvelope, FaInbox, FaFilter, FaInfoCircle } from "react-icons/fa";
import { allAPiServicesCall } from "../../../services/apiServices";
import { getAuthConfig } from "../../../services/apiUtils";
import { useNavigate } from "react-router-dom";
import CommonLayout from "../../../layouts/CommonLayout";
import "./Contactus.css";

const Contactus = () => {
    const [contactUs, setContactUs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedContactUs, setSelectedContactUs] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const getContactUs = async () => {
        try {
            const response = await allAPiServicesCall.getContactus(
                {},
                getAuthConfig(),
                navigate
            );
            setContactUs(response.data);
        } catch (error) {
            console.log("error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewMore = (contactus) => {
        setSelectedContactUs(contactus);
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {
        getContactUs();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    return (
        <CommonLayout>
            <div className="contactus-page">
                {/* Header - Matching Artists Page */}
                <div className="contactus-header">
                    <div className="contactus-header-top">
                        <div className="contactus-title-wrapper">
                            <div className="contactus-title-icon">
                                <FaEnvelope />
                            </div>
                            <div className="contactus-title-text">
                                <h1 className="contactus-title">Contact Us</h1>
                                <p className="contactus-subtitle">Manage and respond to customer inquiries</p>
                            </div>
                        </div>
                        <div className="contactus-stats">
                            <div className="contactus-stat-badge">
                                <FaInbox />
                                <span>Total: <strong>{contactUs.length.toLocaleString()}</strong></span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Filter Section - Matching Artists Page */}
                <div className="contactus-filter-section">
                    <div className="contactus-filter-header">
                        <div className="contactus-filter-icon">
                            <FaFilter />
                        </div>
                        <h3 className="contactus-filter-title">All Messages</h3>
                    </div>
                    <div className="contactus-filter-hint">
                        <FaInfoCircle size={12} />
                        <span>Browse through all customer inquiries and messages</span>
                    </div>
                </div>

                {/* Main Card */}
                <div className="contactus-card">
                    {loading ? (
                        <div className="contactus-loading">
                            <div className="contactus-loading-spinner"></div>
                            <span className="contactus-loading-text">Loading messages...</span>
                        </div>
                    ) : contactUs.length === 0 ? (
                        <div className="contactus-empty">
                            <FaInbox className="contactus-empty-icon" />
                            <span className="contactus-empty-text">No messages yet.</span>
                            <span className="contactus-empty-subtitle">When customers reach out, their messages will appear here.</span>
                        </div>
                    ) : (
                        <>
                            {/* Desktop Table View */}
                            <div className="contactus-table-container">
                                <table className="contactus-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 60 }}>#</th>
                                            <th style={{ width: '18%' }}>Name</th>
                                            <th style={{ width: '22%' }}>Email</th>
                                            <th style={{ width: '15%' }}>Subject</th>
                                            <th style={{ width: '20%' }}>Message</th>
                                            <th style={{ width: '12%' }}>Date</th>
                                            <th style={{ width: 100 }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contactUs.map((contact, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <span className="contactus-id">{index + 1}</span>
                                                </td>
                                                <td>
                                                    <span className="contactus-name">
                                                        {contact.firstName} {contact.lastName}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="contactus-email">{contact.email}</span>
                                                </td>
                                                <td>
                                                    <span className="contactus-subject-badge">
                                                        {contact.subject || "General Inquiry"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="contactus-message-preview">
                                                        {contact.message.length > 40
                                                            ? contact.message.substring(0, 40) + "..."
                                                            : contact.message}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="contactus-date">
                                                        {formatDate(contact.createdAt)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        className="contactus-btn contactus-btn-view"
                                                        onClick={() => handleViewMore(contact)}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile Card View */}
                            <div className="contactus-mobile-view">
                                {contactUs.map((contact, index) => (
                                    <div key={index} className="contactus-mobile-card">
                                        <div className="contactus-mobile-card-header">
                                            <div className="contactus-mobile-card-icon">
                                                <FaEnvelope />
                                            </div>
                                            <div className="contactus-mobile-card-info">
                                                <h3 className="contactus-mobile-card-name">
                                                    {contact.firstName} {contact.lastName}
                                                </h3>
                                                <span className="contactus-mobile-card-email">{contact.email}</span>
                                            </div>
                                        </div>
                                        <div className="contactus-mobile-card-meta">
                                            <span className="contactus-subject-badge">
                                                {contact.subject || "General Inquiry"}
                                            </span>
                                            <span className="contactus-date">{formatDate(contact.createdAt)}</span>
                                        </div>
                                        <p className="contactus-mobile-card-message">
                                            {contact.message.length > 80
                                                ? contact.message.substring(0, 80) + "..."
                                                : contact.message}
                                        </p>
                                        <div className="contactus-mobile-card-actions">
                                            <button
                                                className="contactus-btn contactus-btn-view"
                                                onClick={() => handleViewMore(contact)}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Premium Modal */}
            {selectedContactUs && (
                <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    centered
                    size="lg"
                    className="contactus-modal"
                >
                    <Modal.Header closeButton className="contactus-modal-header">
                        <Modal.Title className="contactus-modal-title">
                            <FaEnvelope />
                            Message Details
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="contactus-modal-body">
                        <div className="contactus-detail-grid">
                            <div className="contactus-detail-item">
                                <div className="contactus-detail-label">First Name</div>
                                <div className="contactus-detail-value">{selectedContactUs.firstName}</div>
                            </div>
                            <div className="contactus-detail-item">
                                <div className="contactus-detail-label">Last Name</div>
                                <div className="contactus-detail-value">{selectedContactUs.lastName}</div>
                            </div>
                        </div>
                        <div className="contactus-detail-item">
                            <div className="contactus-detail-label">Email Address</div>
                            <div className="contactus-detail-value contactus-detail-email">{selectedContactUs.email}</div>
                        </div>
                        <div className="contactus-detail-item">
                            <div className="contactus-detail-label">Subject</div>
                            <div className="contactus-detail-value">{selectedContactUs.subject || "General Inquiry"}</div>
                        </div>
                        <div className="contactus-detail-item">
                            <div className="contactus-detail-label">Message</div>
                            <div className="contactus-detail-message">{selectedContactUs.message}</div>
                        </div>
                        <div className="contactus-detail-item">
                            <div className="contactus-detail-label">Received On</div>
                            <div className="contactus-detail-value">
                                {new Date(selectedContactUs.createdAt).toLocaleDateString('en-US', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="contactus-modal-footer">
                        <Button className="contactus-btn contactus-btn-close" onClick={handleCloseModal}>
                            Close
                        </Button>
                        <Button
                            className="contactus-btn contactus-btn-reply"
                            onClick={() => window.location.href = `mailto:${selectedContactUs.email}`}
                        >
                            Reply
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </CommonLayout>
    );
};

export default Contactus;
